/**
 * Determine if a toast notification should be shown for a rate update
 */
export const shouldShowToast = (rate: number, minimumRate: number): boolean => {
  return rate >= minimumRate;
};
